<template>
  <div class="root">
    <ul class="list" :class="{ docList: showDocList}" v-if="showList">
      <li class="head">
        <span class="first-col">
          <div class="first-row"></div>
        </span>
        <span class="name">{{$t('list.name')}}</span>

        <!-- doc view -->
        <span v-if="showDocList" class="stock-code">{{$t('list.stock-code')}}</span>
        <span v-if="showDocList" class="doc-issuer">{{$t('list.document-issuer')}}</span>

        <!-- graph view -->
        <span v-if="showGraphList" class="data-source">{{$t('list.data-source')}}</span>
        <span class="last-modified">{{$t('list.last-modified')}}</span>
        <span class="option"></span>
      </li>
      <li
        v-for="(item, index) in contentFilter"
        :class="{
          select: beSelected.includes(item.o_id),
          active:index==listHover||index==closetShow,
          'doc-detail': showDocList && item.type == 'doc'
        }"
        :key="item['o_id']"
        @click="selectOrEnter(item)"
        @mouseenter="enterList(index)"
        @mouseleave="leaveList(index)"
      >
        <span class="first-col">
          <div class="first-row">
            <div class="checkBox" v-if="editMode"></div>
            <span
              class="icon"
              :class="{ doc: item.type == 'doc', graph: item.type == 'graph' }"
            >{{ getType(item) }}</span>
          </div>
        </span>
        <span
          class="icon sm-case-link"
          v-if="showCaseBadge(item)"
          @mouseenter="showPopover(index)"
          @mouseleave="hidePopover"
        >
          &#xe92d;
          <popover v-if="index == nowHover" :caseName="caseBelong(item)" @linkToCase="linkToCase"></popover>
        </span>
        <span class="name" :title="item.name||item.caseName">
          <p>{{ item.name || item.caseName }}</p>
        </span>

        <!-- doc view -->
        <span v-if="showDocList" class="stock-code">{{ item.stockCode }}</span>
        <span v-if="showDocList" class="doc-issuer">
          {{ item.companyName_cn }}
          <br />
          {{ item.companyName_en }}
        </span>

        <!-- graph view -->
        <span v-if="showGraphList" class="data-source">
          {{
          item.dataSource
          }}
        </span>
        <span class="last-modified">{{ item.lastSaved }}</span>
        <span class="option">
          <div
            class="icon"
            v-show="index==listHover||index==closetShow"
            @click.stop="showCloset(index)"
          >&#xe98a;</div>
          <file-closet
            :actions="actions"
            :position="`left`"
            @actionSelect="actionSelect"
            @moveToCase="itemMove"
            v-if="closetShow==index"
          ></file-closet>
        </span>
      </li>
    </ul>
    <div class="blank" v-else>No File</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import popover from "@/components/popover";
import fileCloset from "@/components/fileCloset";
export default {
  components: {
    popover,
    fileCloset
  },
  props: {
    cases: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState([
      "editMode",
      "beSelected",
      "allCases",
      "tagBeSelected",
      "keyWord",
      "requestPending"
    ]),
    contentFilter() {
      return this.caseFilter.concat(this.itemFilter);
    },
    showDocList() {
      return (
        this.type == "doc" ||
        this.type == "tagSearch" ||
        (this.type == "inCase" && this.$curPath()[0] == "doc")
      );
    },
    showGraphList() {
      return (
        this.type == "graph" ||
        (this.type == "inCase" && this.$curPath()[0] == "graph")
      );
    },
    caseFilter() {
      let cases = this.cases;
      if (this.type == "search") {
        cases = cases.filter(v => {
          let reg = new RegExp(this.keyWord, "i");
          let flag = reg.test(v.caseName);
          return flag;
        });
      }
      return cases;
    },
    itemFilter() {
      let items = this.items;
      if (this.type == "search") {
        items = items.filter(v => {
          let reg = new RegExp(this.keyWord, "i");
          let match = ["name", "companyName_cn", "companyName_en", "stockCode"];
          let flag = match.some(cur_match => {
            if (v[cur_match]) {
              return reg.test(v[cur_match]);
            }
            return false;
          });

          return flag;
        });
      }
      return items;
    },
    showList() {
      return (
        this.items.length !== 0 ||
        this.cases.length !== 0 ||
        this.itemFilter.length !== 0
      );
    },
    inCase() {
      return this.contentFilter[this.closetShow]["case_belong_id"];
    },
    caseName() {
      return this.allCases.map(v => {
        return v["caseName"];
      });
    },
    actions() {
      let actions;
      if (this.contentFilter[this.closetShow]["type"]) {
        actions = [
          {
            icon: "\ue92d",
            action: "action.moveto",
            next: true,
            childList: this.caseName
          },
          { icon: "\ue926", action: "action.delete" }
        ];

        if (this.inCase) {
          actions.splice(1, 0, { icon: "\ue9ab", action: "action.moveout" });
        }
      } else {
        actions = [
          { icon: "\ue962", action: "action.rename" },
          { icon: "\ue926", action: "action.delete" }
        ];
      }
      return actions;
    },
    cur_select() {
      return this.contentFilter[this.closetShow];
    },
    caseBelongIndex() {
      let caseOid = this.cur_select["case_belong_id"];
      for (let i in this.allCases) {
        if (this.allCases[i]["o_id"] == caseOid) {
          return Number(i);
        }
      }
      return -1;
    }
  },
  data() {
    return {
      nowHover: -1,
      listHover: -1,
      closetShow: -1
    };
  },
  methods: {
    ...mapMutations(["select", "clearTagSelect", "clearKeyword", "caseRename"]),
    ...mapActions([
      "delete",
      "itemMoveOut",
      "moveItemToNewCase",
      "moveItem",
      "update"
    ]),
    actionSelect(index) {
      let actionBeSelect = this.actions[index]["action"];
      switch (actionBeSelect) {
        case "action.moveout":
          this.moveOut();
          return;
        case "action.delete":
          this.itemDelete();
          return;
        case "action.rename":
          this.rename();
          return;
      }
    },
    itemDelete() {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      this.$dialog({
        type: "confirm",
        name: this.cur_select["caseName"] || this.cur_select["name"],
        title: "dialog.action-confirm"
      });
      this.$fire.$on("confirm", confirm => {
        if (confirm) {
          this.select(this.cur_select["o_id"]);
          this.hideCloset();
          this.delete()
            .then(() => {
              this.$toast();
            })
            .catch(() => {
              this.$toast({ status: 1, forceFadeOut: true });
            });
          this.$toast({ status: 2 });
        }
        this.$fire.$off("confirm");
      });
    },
    rename() {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      this.$dialog({ type: "dialog", title: "dialog.rename-case" });
      this.$fire.$on("caseName", (data, timestamp) => {
        if (data) {
          let backupName = this.cur_select["caseName"];
          let vc_id = this.cur_select["o_id"].slice(1);
          this.caseRename({ name: data, oid: this.cur_select["o_id"] });
          this.hideCloset();
          this.update({
            action: "renameCase",
            case_title: data,
            vc_id: vc_id
          })
            .then(res => {
              if (res.data.code == 200) {
                this.$toast();
              } else {
                this.caseRename({
                  name: backupName,
                  index: this.cur_select["o_id"]
                });
                this.$toast({ status: 1, forceFadeOut: true });
              }
            })
            .catch(res => {
              this.caseRename({
                name: backupName,
                index: this.cur_select["o_id"]
              });
              this.$toast({ status: 1, forceFadeOut: true });
            });
          this.$toast({ status: 2 });
        }
        this.$fire.$off("caseName");
      });
    },
    moveOut() {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      this.select(this.cur_select["o_id"]);

      this.itemMoveOut()
        .then(() => {
          this.$toast();
        })
        .catch(() => {
          this.$toast({ status: 1, forceFadeOut: true });
        });
      this.$toast({ status: 2 });
    },
    itemMove(index) {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      if (index == this.caseBelongIndex && index !== -1) {
        return;
      }
      let payload = {};
      if (index < 0) {
        this.moveToNewCase();
      } else {
        let target_case = this.allCases[index].o_id;
        payload["target_case"] = target_case;
        this.select(this.cur_select["o_id"]);
        this.hideCloset();
        this.moveItem(payload)
          .then(() => {
            this.$toast();
          })
          .catch(() => {
            this.$toast({ status: 1, forceFadeOut: true });
          });
        this.$toast({ status: 2 });
      }
    },
    moveToNewCase() {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      this.select(this.cur_select["o_id"]);
      this.$dialog({ type: "dialog" });
      this.$fire.$on("caseName", (data, timestamp) => {
        if (data) {
          this.hideCloset();
          this.moveItemToNewCase({ name: data, timestamp: timestamp })
            .then(() => {
              this.$toast();
            })
            .catch(() => {
              this.$toast({ status: 1, forceFadeOut: true });
            });
          this.$toast({ status: 2 });
        }
        this.$fire.$off("caseName");
      });
    },
    hideCloset() {
      this.closetShow = -1;
      document.removeEventListener("click", this.hideCloset);
    },
    showCloset(index) {
      this.closetShow = index;
      document.addEventListener("click", this.hideCloset);
    },
    enterList(index) {
      this.listHover = index;
    },
    leaveList() {
      this.listHover = -1;
    },
    getType(item) {
      let type = item.type || "case";
      switch (type) {
        case "case":
          return "\ue92d";
        case "doc":
          return "\ue9ac";
        case "graph":
          return "\ue908";
      }
    },
    showCaseBadge(item) {
      return (
        item["case_belong_id"] &&
        (this.type == "search" || this.type == "tagSearch")
      );
    },
    selectOrEnter(item) {
      if (this.editMode) {
        this.select(item.o_id);
      } else {
        if (item.caseName) {
          this.$router.push(`/${this.$curPath()[0]}/${item.caseName}`);
        } else {
          window.open(item.url);
        }
      }
    },
    routerHandle(path) {
      if (this.$curPath()[1] == "tag") {
        this.clearTagSelect();
        this.$nextTick(function() {
          this.$router.replace(path);
        });
      } else if (this.$curPath()[0] == "search") {
        this.clearKeyword();
        this.$nextTick(function() {
          this.$router.replace(path);
        });
      } else {
        this.$router.replace(path);
      }
    },
    linkToCase(caseName) {
      this.hidePopover();
      let path = `/case/${caseName}`;
      this.routerHandle(path);
    },
    caseBelong(item) {
      let caseOid = item["case_belong_id"];
      let now_case;
      for (let i in this.allCases) {
        if (this.allCases[i]["o_id"] == caseOid) {
          now_case = this.allCases[i];
        }
      }
      return now_case.caseName;
    },
    showPopover(index) {
      this.nowHover = index;
    },
    hidePopover() {
      this.nowHover = -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.list,
.docList {
  margin-top: 20px;
  border-top: 1px solid $border-color;
  li {
    @include flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 30px;
    border-bottom: 1px solid $border-color;
    list-style: none;
    &:not(.head):hover {
      background-color: #e5e7ea;
      cursor: pointer;
    }
    &.active {
      background-color: #e5e7ea;
      cursor: pointer;
    }
  }
  li > span {
    color: $dark-purple;
    font-size: 14px;
  }
  li.head span {
    line-height: 30px;
    font-size: 16px;
    font-weight: 500;
  }
  li.select > .first-col > .first-row .checkBox {
    background-color: $light-purple;
    &::after {
      content: "\e99e";
      font-family: "gekko_fonts" !important;
      font-size: 8px;
      @include center;
      color: $base-color;
      position: absolute;
    }
  }

  li > .first-col > .first-row,
  li > .first-col > .case-link {
    @include flex;
    position: relative;
    justify-content: space-between;
    flex-shrink: 0;
    width: 54px;
    padding: 0 6px;
    .icon {
      margin-left: auto;
      color: $dark-purple;
      font-size: 20px;
      &.graph {
        color: $graph-color;
      }
      &.doc {
        color: $doc-color;
      }
    }

    & > .checkBox {
      width: 16px;
      height: 16px;
      border: 1px solid $light-purple;
      border-radius: 4px;
      cursor: pointer;
      background-color: $base-color;
      transition: all 300ms;
      position: relative;
    }
  }
  li > .first-col > .case-link {
    margin-left: auto;
    justify-content: flex-end;
    color: $light-purple;
    .icon {
      display: inline-block;
      width: 20px;
      line-height: 30px;
      text-align: center;
      font-size: 16px;
      &:hover {
        color: $dark-purple;
      }
    }
  }
  li > .data-source {
    flex-basis: 345px;
    margin-right: 15px;
    flex-shrink: 1;
  }
  .sm-case-link {
    position: relative;
    font-size: 12px;
    margin-right: 5px;
    color: $dark-purple;
    transition: color 150ms;
    &:hover {
      color: #156ec9;
    }
  }
  li > .name {
    @include flex;
    flex-basis: 1;
    flex-direction: row;
    justify-content: flex-start;
    margin-right: 15px;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  li > .option {
    position: relative;
    display: inline-block;
    height: 30px;
    flex-basis: 20px;
    flex-shrink: 0;
    & > div.icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: $light-purple;
      font-size: $font-base-size + 4px;
    }
  }
  li > .last-modified {
    flex-shrink: 0;
    flex-basis: 170px;
    margin-right: 35px;
  }
}
.docList {
  li.doc-detail {
    height: 60px;
    & > span {
      line-height: 30px;
      align-self: flex-start;
    }
    & > span.name {
      height: 60px;
      margin-right: 15px;
      align-items: flex-start;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
    }
  }
  li > .first-col .icon.doc {
    line-height: 30px;
  }
  li > .stock-code {
    flex-shrink: 0;
    width: 100px;
    margin-right: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  li > .doc-issuer {
    flex-shrink: 0;
    width: 185px;
    margin-right: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.root {
  width: 100%;
}
.blank {
  @include flex;
  color: #e1e3e7;
  font-size: 30px;
  font-weight: 600;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/listView.vue